import React, { useEffect, useState } from "react";
import { HiOutlineMail } from "react-icons/hi";
import { AiOutlineEyeInvisible } from "react-icons/ai";
import { BiShowAlt } from "react-icons/bi";
import Popup from "../../popup/Popup";
import { NavLink, useNavigate } from "react-router-dom";
import {
  showMessage,
  makeAjax,
  url,
  respStatus,
} from "../../../helpers/global_helper";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { getPlayerProfileDetail } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import ActionLoader from "../../../pages/ActionLoader";

const ValidationMailVarification = (props) => {
  const InitFormData = {
    email_id: "",
    password: "",
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isPopupInvalidEmail, setIsPopupInvalidEmail] = useState(false);
  const [hasVerificationEmailSent, setHasVerificationEmailSent] =
    useState(false);
  const [formError, setFormError] = useState({});
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [formSuccess, setFormSuccess] = useState(false);
  const [loaderStatus, setLoader] = useState(false);
  const [loaderVerifyStatus, setVerifyLoader] = useState(false);
  const [inputType, setInputType] = useState("password");
  const [isDesktop, setIsDesktop] = useState(true);

  const [formData, setFormData] = useState({
    email_id: "",
  });
  const [popUpData, setPopUpData] = useState({
    email_id: "",
    please_check: "",
  });

  const [formDataChangeEmail, setFormDataChangeEmail] = useState(InitFormData);
  const [formErrorChangeEmail, setFormErrorChangeEmail] = useState({});
  const [changeEmailData, setChangeEmailData] = useState(false);
  const [isErrorMessagePopUpChangeEmail, setIsErrorMessagePopUpChangeEmail] = useState(false);

  const [isErrorMessagePopUp, setIsErrorMessagePopUp] = useState(false);

  const [isSuccessMessagePopUp, setIsSuccessMessagePopUp] = useState(false);

  const { userProfile } = useSelector((state) => ({
    userProfile: state.playerProfileR?.data ?? {},
  }));

  useEffect(() => {
    dispatch(getPlayerProfileDetail());
  }, []);

  const checkEmailVerified = () => {
    let verified_email = false;
    if (userProfile.email_verified_at) verified_email = true;
    setIsEmailVerified(verified_email);
  };

  useEffect(() => {
    checkEmailVerified();
  }, [userProfile]);

  const verifyOnEmailSubmit = (e) => {
    e.preventDefault();
    setVerifyLoader(true);
    makeAjax(url.USER_API.emailVerification, formData, url.USER_MS_EXT).then(
      (response) => {
        if (response.status != respStatus["SUCCESS"]) {
          setVerifyLoader(false);
          if (response.code != "validation_error") showMessage(response);
          setFormError(response.messages);
          return;
        }
        setVerifyLoader(false);
        setFormError({});
        setPopUpData(response.data);
        setFormData({ ...formData, ...{ email_id: "" } });
        setFormSuccess(response.messages);
        setHasVerificationEmailSent(true);
        dispatch(getPlayerProfileDetail());
      }
    );
  };

  const changeEmail = () => {
    setIsEmailVerified(true);
  };

  const handlePopup = () => {
    setIsPopupInvalidEmail(false);
    setIsErrorMessagePopUp(false);
    setIsErrorMessagePopUpChangeEmail(false);
  };

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
    setFormError({ ...formError, [event.target.name]: "" });
  };

  const handleChangeEmail = (event) => {
    setFormDataChangeEmail({
      ...formDataChangeEmail,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    makeAjax(
      url.USER_API.changeEmail,
      formDataChangeEmail,
      url.USER_MS_EXT
    ).then((response) => {
      if (response.status != respStatus["SUCCESS"]) {
        setLoader(false);
        if (response.code != "validation_error") showMessage(response);
        setFormErrorChangeEmail(response.messages);
        setIsErrorMessagePopUpChangeEmail(true);
        return;
      }
      setLoader(false);
      setFormSuccess(response.messages);
      setPopUpData(response.data);
      setFormDataChangeEmail(InitFormData);
      setIsSuccessMessagePopUp(true);
      dispatch(getPlayerProfileDetail());
    });
  };

  const handleSuccess = () => {
    setIsEmailVerified(true);
    setIsSuccessMessagePopUp(false);
    setHasVerificationEmailSent(true);
  };


  const handleMouseOver = () => {
    if (isDesktop) {
      if (inputType == "password") setInputType("text");
      if (inputType == "text") setInputType("password");
    }
  };

  const handleClick = () => {
    if (!isDesktop) {
      if (inputType == "password") setInputType("text");
      if (inputType == "text") setInputType("password");
    }
  };

  const handelOkeyBtn = () => {
    setHasVerificationEmailSent(!hasVerificationEmailSent);
    props.handle();
  }

  return (
    <div className='popup-box validation-verification'>
      {!isEmailVerified && !hasVerificationEmailSent && (
        <div className="form-div">
          <h4 className="title">{props.t("email_verification")}</h4>
          <form onSubmit={verifyOnEmailSubmit}>
            <div className="input-control">
              <input
                type="email"
                name="email_id"
                placeholder={props.t("enter_your_email")}
                onChange={handleChange}
              />
              {formError.email_id ? (
                <span className="text-danger d-flex error-msg">
                  {formError.email_id[0]}
                </span>
              ) : null}
            </div>
            <div className="pt-2 d-flex justify-content-center">
              <ActionLoader
                label={"process"}
                loaderClass={"verify-email-loader text_button-continue"}
                showLoader={loaderVerifyStatus}
              />
            </div>
          </form>
        </div>
      )}

      {hasVerificationEmailSent && (
        <div className="container">
          <div className="verification-confirm">
            <HiOutlineMail className="icon" />
            <p>
              {popUpData.verification_link} <br />
              {popUpData.email_id}, {popUpData.please_check}
            </p>
            <div className="d-flex justify-content-center">
              <button onClick={() => handelOkeyBtn()}>
                {props.t("okay")}
              </button>
            </div>
          </div>
        </div>
      )}
      {isPopupInvalidEmail && (
        <Popup
          handlePoup={handlePopup}
          data={[formError.email_id]}
          invalidEmail
        />
      )}
      {/* Error Message Pop Up */}
      {isErrorMessagePopUp && (
        <Popup handlePoup={handlePopup} data={[formError]} errorMessages />
      )}
      {isErrorMessagePopUpChangeEmail && (
        <Popup
          handlePoup={handlePopup}
          data={[formErrorChangeEmail]}
          errorMessages
        />
      )}

      {/* Success Message Pop Up */}
      {isSuccessMessagePopUp && (
        <Popup
          handlePoup={handleSuccess}
          data={[formSuccess]}
          successMessages
        />
      )}

    </div>
  );
};

ValidationMailVarification.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(ValidationMailVarification);
